export default __webpack_public_path__ + "static/visualbutton2_compressed-bcb88f3308c5b12d08733d8befead6ce.jpg";